import { NONE_ID, NONE_NAME } from 'src/Utils/globalConstants'
import { INDEX_PAGE_WITH_FILTERS } from '../IndexPage.constants'

export type FilterBarConfig = {
  department?: boolean
  policy?: boolean
  status?: boolean
  audit_run_owner?: boolean
  audit_run_control?: boolean
  audit_run_status?: boolean
  audit_run_result?: boolean
  owner?: boolean
  ownerLabel?: string
  auditIncludeNone?: boolean
  controlIncludeNone?: boolean
  organization?: boolean
  assignee?: boolean
  questionnaireStatus?: boolean
  questionnaireDateRange?: boolean
  documentation?: boolean
  complianceFramework?: boolean
  audit?: boolean
  auditFrameworks?: boolean
  auditStatus?: boolean
  risk?: boolean
  receptor?: boolean
  serviceRole?: boolean
  riskTier?: boolean
  attestation?: boolean
  smartChecks?: boolean
  source?: boolean
  visibilities?: boolean
  tags?: boolean
  evidenceType?: boolean
  fileType?: boolean
  folderScan?: boolean
  dateRange?: boolean
  control?: boolean
  frameworkType?: boolean
  frameworkName?: boolean
  trustPortalRequestAccess?: boolean
  trustPortalPermission?: boolean
  trustPortalFeatures?: boolean
  company?: boolean
  reportType?: boolean
  trustServiceCriteria?: boolean
  auditor?: boolean
  expirationDate?: boolean
  userDepartment?: boolean
  userRole?: boolean
  emailNotification?: boolean
  dashboardFramework?: boolean
  dashboardPolicy?: boolean
  dashboardAudit?: boolean
  dashboardRisk?: boolean
  dashboardDepartment?: boolean
  dashboardAssignee?: boolean
  dashboardDateRange?: boolean
  reportCategories?: boolean
  dashboardControl?: boolean
  dashboardRiskCategory?: boolean
  dashboardVendor?: boolean
  dashboardName?: boolean
  dashboardEmail?: boolean
  dashboardCompany?: boolean
  dashboardDocName?: boolean
  dashboardTPFeature?: boolean
  dashboardTPAccessLevel?: boolean
  dashboardTPUpdateCategory?: boolean
  dashboardLabel?: boolean
  executionType?: boolean
  playbookType?: boolean
  playbookCategory?: boolean
  documentScan?: boolean
  requestType?: boolean
  label?: boolean
  section?: boolean
  overviewFramework?: boolean
  overviewDateRange?: boolean
}

type FilterBarConfigType = {
  [key in INDEX_PAGE_WITH_FILTERS]: FilterBarConfig
}

export const FilterBarConfigs: FilterBarConfigType = {
  [INDEX_PAGE_WITH_FILTERS.CONTROLS]: {
    department: true,
    policy: true,
    status: true,
    owner: true,
    complianceFramework: true,
    audit: true,
    label: true,
  },
  [INDEX_PAGE_WITH_FILTERS.CONTROLS_AI]: {
    department: true,
    policy: true,
    status: true,
    owner: true,
    complianceFramework: true,
    audit: true,
    smartChecks: true,
  },
  [INDEX_PAGE_WITH_FILTERS.POLICIES]: {
    department: true,
    owner: true,
    documentation: true,
    complianceFramework: true,
    audit: true,
    label: true,
  },
  [INDEX_PAGE_WITH_FILTERS.RISKS]: {
    department: true,
    status: true,
    owner: true,
    risk: true,
  },
  [INDEX_PAGE_WITH_FILTERS.REQUESTS]: {
    requestType: true,
    status: true,
    owner: true,
    ownerLabel: 'Assignee',
    audit: true,
    auditIncludeNone: true,
  },
  [INDEX_PAGE_WITH_FILTERS.SERVICES]: {
    receptor: true,
    serviceRole: true,
  },
  [INDEX_PAGE_WITH_FILTERS.RECEPTORS]: {
    status: true,
  },
  [INDEX_PAGE_WITH_FILTERS.FRAMEWORKS]: {
    frameworkName: true,
    audit: true,
    auditIncludeNone: true,
    control: true,
    controlIncludeNone: true,
    frameworkType: true,
  },
  [INDEX_PAGE_WITH_FILTERS.FRAMEWORK_REQUIREMENTS]: {
    section: true,
    control: true,
    department: true,
    label: true,
  },
  [INDEX_PAGE_WITH_FILTERS.VENDORS]: {
    owner: true,
    riskTier: true,
    attestation: true,
  },
  [INDEX_PAGE_WITH_FILTERS.EVIDENCE]: {
    source: true,
    evidenceType: true,
    fileType: true,
    dateRange: true,
    control: true,
  },
  [INDEX_PAGE_WITH_FILTERS.DOCUMENT_SCAN]: {
    status: true,
    documentScan: true,
  },
  [INDEX_PAGE_WITH_FILTERS.SECURITY_QUESTIONNAIRE]: {
    questionnaireDateRange: true,
    organization: true,
    assignee: true,
    questionnaireStatus: true,
  },
  [INDEX_PAGE_WITH_FILTERS.AUDIT_BOT]: {
    dateRange: true,
    audit_run_owner: true,
    audit_run_control: true,
    audit_run_status: true,
    audit_run_result: true,
  },
  [INDEX_PAGE_WITH_FILTERS.REPORT_SCAN]: {
    company: true,
    reportType: true,
    trustServiceCriteria: true,
    auditor: true,
    expirationDate: true,
  },
  [INDEX_PAGE_WITH_FILTERS.USERS]: {
    userDepartment: true,
    userRole: true,
    emailNotification: true,
  },
  [INDEX_PAGE_WITH_FILTERS.AUDIT]: {
    auditFrameworks: true,
    dateRange: true,
    auditStatus: true,
  },
  [INDEX_PAGE_WITH_FILTERS.OE_DASHBOARD_OVERVIEW]: {
    dashboardFramework: true,
    dashboardPolicy: true,
    dashboardRisk: true,
    dashboardDepartment: true,
    dashboardAssignee: true,
    dashboardLabel: true,
    dashboardDateRange: true,
  },
  [INDEX_PAGE_WITH_FILTERS.OE_DASHBOARD_DETAIL]: {
    dashboardFramework: true,
    dashboardPolicy: true,
    dashboardRisk: true,
    dashboardDepartment: true,
    dashboardAssignee: true,
    dashboardLabel: true,
    dashboardDateRange: true,
  },
  [INDEX_PAGE_WITH_FILTERS.REPORTS]: {
    reportCategories: true,
  },
  [INDEX_PAGE_WITH_FILTERS.RISK_RESPONSE_DASHBOARD]: {
    dashboardDepartment: true,
    dashboardRiskCategory: true,
    dashboardVendor: true,
    dashboardControl: true,
    dashboardAssignee: true,
    dashboardDateRange: true,
  },
  [INDEX_PAGE_WITH_FILTERS.TP_ACCESS_REQUESTS_DASHBOARD]: {
    dashboardDateRange: true,
    dashboardName: true,
    dashboardEmail: true,
    dashboardCompany: true,
    dashboardTPFeature: true,
  },
  [INDEX_PAGE_WITH_FILTERS.TP_GRANTED_REQUESTS_DASHBOARD]: {
    dashboardDateRange: true,
    dashboardName: true,
    dashboardEmail: true,
    dashboardCompany: true,
    dashboardTPFeature: true,
  },
  [INDEX_PAGE_WITH_FILTERS.TP_DOCUMENT_DOWNLOADS_DASHBOARD]: {
    dashboardDateRange: true,
    dashboardName: true,
    dashboardEmail: true,
    dashboardCompany: true,
    dashboardDocName: true,
    dashboardTPAccessLevel: true,
  },
  [INDEX_PAGE_WITH_FILTERS.TP_FAQ_CLICKS_DASHBOARD]: {
    dashboardDateRange: true,
    dashboardName: true,
    dashboardEmail: true,
    dashboardCompany: true,
  },
  [INDEX_PAGE_WITH_FILTERS.TP_SEARCHES_DASHBOARD]: {
    dashboardDateRange: true,
    dashboardName: true,
    dashboardEmail: true,
    dashboardCompany: true,
  },
  [INDEX_PAGE_WITH_FILTERS.TP_TI_CHATS_DASHBOARD]: {
    dashboardDateRange: true,
    dashboardName: true,
    dashboardEmail: true,
    dashboardCompany: true,
  },
  [INDEX_PAGE_WITH_FILTERS.TP_TI_QUESTIONS_DASHBOARD]: {
    dashboardDateRange: true,
    dashboardName: true,
    dashboardEmail: true,
    dashboardCompany: true,
  },
  [INDEX_PAGE_WITH_FILTERS.TP_UPDATE_NOTIFICATION_SUBSCRIPTIONS_DASHBOARD]: {
    dashboardDateRange: true,
    dashboardName: true,
    dashboardEmail: true,
    dashboardCompany: true,
    dashboardTPUpdateCategory: true,
  },
  [INDEX_PAGE_WITH_FILTERS.TP_UPDATE_NOTIFICATION_UNSUBSCRIPTIONS_DASHBOARD]: {
    dashboardDateRange: true,
    dashboardName: true,
    dashboardEmail: true,
    dashboardCompany: true,
    dashboardTPUpdateCategory: true,
  },
  [INDEX_PAGE_WITH_FILTERS.SCHEDULING]: {
    executionType: true,
  },
  [INDEX_PAGE_WITH_FILTERS.PLAYBOOKS]: {
    playbookType: true,
    playbookCategory: true,
  },
  [INDEX_PAGE_WITH_FILTERS.OVERVIEW_DASHBOARD]: {
    overviewFramework: true,
    dashboardLabel: true,
    dashboardDepartment: true,
    dashboardAssignee: true,
    overviewDateRange: true,
  },
}

export const TRUST_PORTAL_REQUEST_ACCESS_CONFIG = {
  department: false,
  policy: false,
  status: false,
  owner: false,
  organization: false,
  documentation: false,
  complianceFramework: false,
  audit: false,
  risk: false,
  receptor: false,
  serviceRole: false,
  riskTier: false,
  attestation: false,
  smartChecks: false,
  source: false,
  evidenceType: false,
  fileType: false,
  dateRange: false,
  control: false,
  trustPortalRequestAccess: true,
  trustPortalPermission: false,
  trustPortalFeatures: true,
}

export const TRUST_PORTAL_PERMISSION_CONFIG = {
  ...TRUST_PORTAL_REQUEST_ACCESS_CONFIG,
  trustPortalRequestAccess: false,
  trustPortalPermission: true,
}

export enum RiskFilterValues {
  NOT_SET = 'not_set',
  SET = 'set',
}

export enum DocumentationFilterValues {
  TRUE = 'true',
  FALSE = 'false',
}

export const NONE_VALUE = {
  value: NONE_ID,
  label: NONE_NAME,
}
